export default "__VITE_ASSET__g4aK4_Ew__"